import {AxiosInstance} from 'axios'
import MyAxiosInstanceCoreAdmin from './axiosInstanceAdminCore'

export class AdminCoreApi {
	private adminCoreApi: AxiosInstance
	constructor() {
		this.adminCoreApi = MyAxiosInstanceCoreAdmin
	}

	
    async getOrganizations(): Promise<any> {
        try {
            const res = await this.adminCoreApi.get('/organizations')
            return res.data
        } catch (error) {
            console.error('Erro ao obter organizações:', error)
            throw error
        }  
    }

    async getOrganizationsTier1(): Promise<any> {
        try {
            const res = await this.adminCoreApi.get('/organizations/?tier=1')
            return res.data
        } catch (error) {
            console.error('Erro ao obter organizações tier 1:', error)
            throw error
        }  
    }

	
}
